export default __webpack_public_path__ + "static/dont-run-25dd41d4373a6a8afa8407c43dc46ab2.png";